import { clarity } from 'react-microsoft-clarity';

import { environment } from '@doger/chat/shared/config';

export class ClarityService {
  public constructor() {
    this.init();
  }

  public init(): void {
    if (environment.stage !== 'PROD') {
      return;
    }

    if (clarity.hasStarted()) {
      return;
    }

    clarity.init(environment.clarity.id);
  }

  public consent(consent: boolean): void {
    try {
      if (!clarity.hasStarted()) {
        return;
      }

      clarity.consent(consent);
    } catch (error) {
      console.error('Failed to consent to Clarity:', error);
    }
  }
}
